import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { ITable } from '../../common/models/table';
import { TenancyScheduleTableHttpService } from '../services/tenancy-schedule-table-http.service';

import * as tenancyScheduleTable from '../actions/tenancy-schedule-table';
import { mergeMap, map, catchError } from 'rxjs';

@Injectable()
export class TenancyScheduleTableEffects {

  constructor(
    private actions$: Actions,
    private tenancyScheduleTableService: TenancyScheduleTableHttpService
  ) { }

  
  loadAll$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTable.Load>(tenancyScheduleTable.LOAD),
    mergeMap((action) => {
      return this.tenancyScheduleTableService.getTenancyScheduleTable(action.context, action.widget.id).pipe(
        map((table: ITable) => new tenancyScheduleTable.LoadComplete(table, action.widget)),
        catchError(err => of(new tenancyScheduleTable.LoadError(err, action.widget)))
      );
    })));

}

